import * as React from 'react'

export const IconXls = (props: { isGrayscale: boolean }) => {
    const colors = [
        props.isGrayscale ? '#B6C1D7' : '#18C764',
        props.isGrayscale ? '#96A2B9' : '#28995A',
        props.isGrayscale ? '#EDF1F7' : '#FFFFFF',
    ]

    return (
        <svg width="32" height="42" viewBox="0 0 32 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2.51955C0 1.12801 1.14513 0 2.55961 0H21L32 9V39.4796C32 40.8712 30.8541 42 29.4396 42H2.55961C1.14513 42 0 40.8712 0 39.4796V2.51955Z"
                fill={colors[0]}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 0V6.42763C21 7.84826 22.181 9 23.6397 9H32"
                fill={colors[1]}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.809 22H17.459V30.316H15.809V22ZM11.112 27.456L9.33 24.97H11.277L12.223 26.422L13.136 24.97H14.973L13.235 27.456L15.292 30.316H13.345L12.179 28.534L10.925 30.316H9L11.112 27.456ZM20.715 26.092C21.111 26.092 21.43 26.2423 21.672 26.543L22.684 25.542C22.4347 25.278 22.1303 25.0947 21.771 24.992C21.4117 24.8893 21.056 24.838 20.704 24.838C20.4253 24.838 20.1503 24.8728 19.879 24.9425C19.6077 25.0122 19.3675 25.1203 19.1585 25.267C18.9495 25.4137 18.7808 25.6007 18.6525 25.828C18.5242 26.0553 18.46 26.3267 18.46 26.642C18.46 26.9793 18.5278 27.2488 18.6635 27.4505C18.7992 27.6522 18.9715 27.808 19.1805 27.918C19.3895 28.028 19.6132 28.1105 19.8515 28.1655C20.0898 28.2205 20.3135 28.2718 20.5225 28.3195C20.7315 28.3672 20.9038 28.4258 21.0395 28.4955C21.1752 28.5652 21.243 28.6697 21.243 28.809C21.243 28.9557 21.166 29.0565 21.012 29.1115C20.858 29.1665 20.6857 29.194 20.495 29.194C20.2457 29.194 20.0275 29.1445 19.8405 29.0455C19.6535 28.9465 19.483 28.8017 19.329 28.611L18.328 29.722C18.592 29.9933 18.9147 30.1822 19.296 30.2885C19.6773 30.3948 20.055 30.448 20.429 30.448C20.715 30.448 21.0047 30.4205 21.298 30.3655C21.5913 30.3105 21.8553 30.2152 22.09 30.0795C22.3247 29.9438 22.5172 29.7642 22.6675 29.5405C22.8178 29.3168 22.893 29.0327 22.893 28.688C22.893 28.3507 22.8252 28.0812 22.6895 27.8795C22.5538 27.6778 22.3815 27.5183 22.1725 27.401C21.9635 27.2837 21.7398 27.1975 21.5015 27.1425C21.2632 27.0875 21.0395 27.0362 20.8305 26.9885C20.6215 26.9408 20.4492 26.8858 20.3135 26.8235C20.1778 26.7612 20.11 26.664 20.11 26.532C20.11 26.3707 20.176 26.257 20.308 26.191C20.44 26.125 20.5757 26.092 20.715 26.092Z"
                fill={colors[2]}
            />
        </svg>
    )
}
